export default __webpack_public_path__ + "static/thinner-e0711436f50467c7f202dd6764202674.png";